import React from "react";
import { InputRangeRow } from "./index";
// Used by Hacoba NSA-HS and Taining S41 machines

export default function LayWheelSettingRow() {
   return (
      <InputRangeRow
         titleProp={"Lay Wheel Setting"}
         descriptionProp={""}
         sizeProp={4}
         typeProp={"text"}
         minProp={0}
         maxProp={38}
         propertyNameProp={"layWheelSet"}
         errorDialogueProp={"0.00-38.00 only"}
         floatProp={true}
      />
   );
}
